export default __webpack_public_path__ + "static/media/chat_icon.5836b500.png";